import { render, staticRenderFns } from "./PlainTextNote.vue?vue&type=template&id=10cda790&"
import script from "./PlainTextNote.vue?vue&type=script&lang=js&"
export * from "./PlainTextNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports